import { render, staticRenderFns } from "./AppStoreFeatured.vue?vue&type=template&id=0507d856&scoped=true&"
import script from "./AppStoreFeatured.vue?vue&type=script&lang=js&"
export * from "./AppStoreFeatured.vue?vue&type=script&lang=js&"
import style0 from "./AppStoreFeatured.scss?vue&type=style&index=0&id=0507d856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0507d856",
  null
  
)

export default component.exports